<template>
  <div>
    <div class="teacher-index wrapper">
      <div class="teacher-index-info" :class="[maskClassName, highClass]" :index="index">
        <div class="avatar">
          <div class="mask">
            <div class="simple-logo" :style="{ backgroundImage: `url(${$t('common.logo.simpleWhite')})` }" />
          </div>
          <img v-lazy-load class="teacher-img" height="254" v-lazy-load :data-src="`${teacher.avatar}?im=Resize=(508,508)`" :alt="teacher.name">
        </div>
        <div class="intro">
          <div class="name font-bold text-overflow-ellipsis">
            {{ teacher.name }}
          </div>
          <div class="education font-medium text-overflow-ellipsis-2">
            {{ teacher.education }}
            <span v-show="teacher.identityTag" class="intro-item teacher-identity-tag text-overflow-ellipsis">
              {{ teacher.identityTag }}
            </span>
          </div>
          <div class="teacher-tags-list">
            <div v-for="(tag, tagIndex) in teacher.highlightList.slice(0,3)" :key="tagIndex" class="tag-item text-overflow-ellipsis" :title="tag">
              {{ tag }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    index: {
      default: 1,
      type: Number,
    },
    teacher: {
      default: () => ({}),
      type: Object,
    },
    showExperience: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
    }
  },
  computed: {
    maskClassName() {
      let { index } = this
      if (this.index > 5) {
        index = this.index % 5
      }
      if (index === 0) {
        index = 5
      }
      return `mask-${index}`
    },
    highClass() {
      return this.showExperience ? 'high' : ''
    },
  },
  mounted() {
    this.teacherCardShow()
  },
  methods: {
    teacherCardShow() {
      const currRoute = this.$route.name
      if (currRoute !== 'teachers') {
        return
      }
      this.Sensors.track('teacher_card_show', {
        content_teacher: this.teacher.name,
        teacher_card_type: '小卡',
        previous_source: 'our teachers',
      })
    },
  },
}

</script>
<style lang="scss" scoped>
.teacher-index {
  border-radius: 12px;
  padding-left: 84px;

  .teacher-index-info {
    background: #fff;
    position: relative;
    padding: 25px;
    border-radius: 12px;
    display: flex;
    align-items: center;

    &.high {
      height: 410px;
    }

    &::after {
      content: " ";
      position: absolute;
      left: 15px;
      top: 15px;
      z-index: 1;
      width: 10px;
      height: 10px;
    }

    &::before {
      content: " ";
      position: absolute;
      right: 15px;
      top: 15px;
      z-index: 1;
      width: 10px;
      height: 10px;
    }

    .avatar {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: -108px;
      position: relative;
      width: 254px;
      height: 254px;
      border-radius: 10px;
      overflow: hidden;
      background-color: #fff;
    }

    .mask {
      position: absolute;
      left: 0;
      top: 0;
      width: 254px;
      height: 254px;
      background-size: cover;

      .simple-logo {
        position: absolute;
        left: 10px;
        top: 10px;
        width: 22px;
        height: 22px;
      }
    }

    &.mask-1 {
      .mask {
        background-image: url("~assets/images/teacher/mask-pink.svg");
      }
    }

    &.mask-2 {
      .mask {
        background-image: url("~assets/images/teacher/mask-green.svg");
      }
    }

    &.mask-3 {
      .mask {
        background-image: url("~assets/images/teacher/mask-blue.svg");
      }
    }

    &.mask-4 {
      .mask {
        background-image: url("~assets/images/teacher/mask-yellow.svg");
      }
    }

    &.mask-5 {
      .mask {
        background-image: url("~assets/images/teacher/mask-purple.svg");
      }
    }

    .intro {
      margin-left: 60px;

      .name {
        height: 60px;
        font-size: 50px;
        font-weight: 600;
        color: var(--txt-color-lv1);
        line-height: 60px;
      }

      .education {
        margin-top: 8px;
        color: var(--txt-color-lv1);
        height: 29px;
        font-size: 24px;
        font-weight: 600;
        line-height: 29px;
        margin-bottom: 30px;
      }

      .teacher-identity-tag {
        margin-left: 40px;
      }

      .teacher-tags-list {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .tag-item {
          // max-width: 260px;
          width: fit-content;
          flex-shrink: 0;
          margin-bottom: 16px;
          margin-right: 10px;
          padding: 12px 20px;
          background: var(--txt-color-link3);
          border-radius: 100px;
          box-sizing: border-box;
          font-size: 16px;
          font-weight: 500;
          color: var(--txt-color-link);
          line-height: 19px;

          .iconfont {
            margin-right: 6px;
          }

          &:last-child {
            margin-right: 0;
          }
        }
      }
    }

    .guide {
      position: absolute;
      width: 100%;
      bottom: 0;
      display: flex;
      justify-content: space-between;
      height: 42px;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 10px;
      padding: 0 8px;

      .name {
        line-height: 42px;
        font-size: 20px;
        color: #fff;
      }

      .icon {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 6px;
        width: 50px;
        height: 30px;
        background: #fff;
        box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.2);
        border-radius: 17px;
      }
    }

    .experience {
      margin-top: 10px;
      height: 114px;
      font-size: 16px;
      font-weight: 500;
      color: #fff;
      line-height: 19px;
    }
  }
}
</style>
